import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import { useAppoitmentStatusList } from "@/app/hooks/api_hooks/dayClosing/useAppoitmentStatusList";
import { useBadInventoryActionsAPI } from "@/app/hooks/api_hooks/Inventory/BadInventory/useBadInventoryActionsAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import { useUtils } from "@/app/hooks/useUtils";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const BadInventoryClosureComponent = () => {
  const { execute: fetchDayClosingData, closureData } = useAppoitmentStatusList();
  const { setVisible: goodToBad, setModalData: goodToBadData } = useModalActions("GOOD_TO_BAD_MODAL");
  const { setVisible: shrinkImage, setModalData: setShrinkImageModalData } = useModalActions("SHRINK_IMAGE_MODAL");

  const { execute: actionsOnBad } = useBadInventoryActionsAPI();

  const { veticDateFormat } = useUtils();
  const queryParams = new URLSearchParams(location.search);
  const isLoading = useLoader("isClosingDataInProgress");
  const { NO_APPOINTMENTS } = useImageConstants();

  const navigate = useNavigate();
  // ✅ read query params
  const processId = queryParams.get("closing_process") ?? "";
  const queryCity = queryParams.get("city_id");
  const queryClinics = queryParams.get("clinic_ids");
  const queryShift = queryParams.get("shift") ?? "day";
  const time = queryParams.get("t") ?? "";
  const city_id = queryParams.get("city_id");
  const isClinicView = queryParams.get("is_clinic");

  useEffect(() => {
    if (queryClinics && queryClinics) {
      fetchDayClosingData(queryClinics, queryShift, "operations", "bad_inventory_action");
    }
  }, [processId, queryCity, queryClinics, queryShift, time]);
  const clinicsWithBadInventory = closureData?.filter((clinic) => clinic?.closure_list?.length > 0) || [];

  const handleActionsClick = (item, KEY) => {
    if (KEY === "MOVE") {
      actionsOnBad({ bad_inventory_id: item.inventory_id, action: "back_to_good" });
      navigate(
        `/app/closing/day-closing?closing_process=${processId}&city_id=${city_id}&clinic_ids=${queryClinics}&is_clinic=${isClinicView}&shift=${queryShift}&t=${Date.now()}`,
      );
    } else {
      goodToBadData({
        key: "re_upload_image",
        vetic_variant_id: item.vetic_variant_id,
        grn_id: item.grn_id,
        sub_grn_id: item.sub_grn_id,
        category_id: item.category,
        bad_qty: item.bad_quantity,
        bad_reason: item.reason_of_inventory_movement,
        re_upload_image: item.re_upload_image,
        sub_category_id: item.sub_category_id,
        unique_row_id: item.unique_row_id,
        bad_inventory_id: item.inventory_id,
        product_name: item.product_name,
        lot_number: item.lot_number,
        manufacturer_name: item.manufacturer_name,
        expiry_date: item.expiry_date,
        mrp: item.mrp,
      });
      goodToBad();
    }
  };

  const handleShrinkImageClick = (item) => {
    setShrinkImageModalData({
      bad_inventory_id: item.inventory_id,
      badProductFilters: null,
    });
    shrinkImage();
  };

  return (
    <div className="w-full">
      {isLoading ? (
        <TableSkeletonComponent columnLength={9} />
      ) : clinicsWithBadInventory.length > 0 ? (
        <div className="overflow-y-auto max-h-[650px] space-y-4">
          {clinicsWithBadInventory.map((clinic: any) => (
            <div
              key={clinic.clinic_details.clinic_id}
              className="rounded-2xl border border-[#ECEEF2] bg-white p-3 shadow-sm"
            >
              <div className="overflow-x-auto rounded-xl">
                <table className="w-full min-w-[1400px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                  <thead className="bg-[#F5F5F5] text-[#1F1F23] text-xs font-normal">
                    <tr>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Items</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Qty</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Lot</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">MRP</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Manufacturer</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Proof</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Status</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Created By</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Action</th>
                    </tr>
                  </thead>
                  <tbody className="text-xs">
                    {clinic.closure_list.map((order: any, rowIndex: number) => {
                      const isFirst = rowIndex === 0;
                      const isLast = rowIndex === clinic.closure_list.length - 1;
                      const isSingle = clinic.closure_list.length === 1;

                      return (
                        <tr
                          key={order?.inventory_id || rowIndex}
                          className={`
                            bg-white hover:bg-[#FCFCFD] transition-colors
                            ${isSingle ? "rounded-xl" : ""}
                            ${isFirst && !isSingle ? "rounded-t-xl" : ""}
                            ${isLast && !isSingle ? "rounded-b-xl" : ""}
                          `}
                        >
                          <td
                            className={`
                              p-3 text-xs
                              ${isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""}
                              ${isFirst && !isSingle ? "rounded-tl-2xl" : ""}
                              ${isLast && !isSingle ? "rounded-bl-2xl" : ""}
                            `}
                          >
                            {order.variant_name}
                            <p className="pt-1">Exp.{veticDateFormat(order?.expiry_date)}</p>
                          </td>
                          <td className="p-3 text-xs">{order.bad_quantity}</td>
                          <td className="p-3 text-xs">{order.vetbuddy_lot_number}</td>
                          <td className="p-3 text-xs">{order?.vetbuddy_mrp || "-"}</td>
                          <td className="p-3 text-xs">{order?.vetbuddy_manufacturer_name}</td>
                          <td className="p-3 text-xs">
                            {order?.inventory_movement_images?.length > 0 ? (
                              <a
                                className="text-blue-600 font-medium underline cursor-pointer"
                                href={order?.inventory_movement_images[0]}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View image
                              </a>
                            ) : (
                              <span className="text-[#6C727F]">-</span>
                            )}
                          </td>
                          <td className="p-3 text-xs whitespace-nowrap">
                            <span
                              className={`px-2 py-1 rounded-full text-xs font-medium ${
                                order.inventory_movement_status === "Invalid Image"
                                  ? "bg-[#FFFAF4] text-[#F44900]"
                                  : "bg-[#FFF4F4] text-[#F40000]"
                              }`}
                            >
                              {order.inventory_movement_status}
                            </span>
                          </td>
                          <td className="p-3 text-xs whitespace-nowrap">
                            <p>{order?.inventory_moved_to_bad_by}</p>
                            <p>{veticDateFormat(order?.inventory_movement_at?.$date)}</p>
                          </td>
                          <td
                            className={`
                              p-3 w-[190px]
                              ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                              ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                              ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                            `}
                          >
                            {order?.inventory_movement_status === "Invalid Image" ? (
                              <button
                                onClick={() => {
                                  handleActionsClick(order, "UPLAOD");
                                }}
                                className="bg-black px-4 py-2 rounded-lg text-[10px] sm:text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                              >
                                Re-Upload Image
                              </button>
                            ) : order?.inventory_movement_status === "Rejected Request" ? (
                              <button
                                onClick={() => {
                                  handleActionsClick(order, "MOVE");
                                }}
                                className="bg-black px-4 py-2 rounded-lg text-[10px] sm:text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                              >
                                Move to Good
                              </button>
                            ) : (
                              order?.inventory_movement_status?.toLowerCase() === "disposable" && (
                                <button
                                  onClick={() => {
                                    handleShrinkImageClick(order);
                                  }}
                                  className="bg-black px-4 py-2 rounded-lg text-[10px] sm:text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                                >
                                  Shrink
                                </button>
                              )
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoDataFoundComponent imageURL={NO_APPOINTMENTS} message="No Orders Found" />
      )}
    </div>
  );
};

export default BadInventoryClosureComponent;
